import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChild, CanDeactivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { NgPopupsService } from 'ng-popups';
import { Observable } from 'rxjs';
import { ComponentCanDeactivate } from './ComponentCanDeactivate'

@Injectable()
export class CanDeactivateGuard implements CanDeactivate<ComponentCanDeactivate> {
    constructor(private _ngPop: NgPopupsService) {}
   
    canDeactivate(component: ComponentCanDeactivate): boolean {
        if (!component.canDeactivate()) {
            // this._ngPop.confirm('Some modification are made, Do you want to exit without saving?', { okButtonText: "Yes", cancelButtonText: "No", title: "Consultant Profile" }).subscribe(res => {
            //     if (res) {
            //         return true;
            //     }
            //     else {
            //         return false;
            //     }
            // })
            
            if (confirm("You have unsaved changes! If you leave, your changes will be lost.")) {
                return true;
            } else {
                return false;
            }
        }
        else {
            return true
        }
    }
}